// 옛 WebView 호환 폴리필은 무엇보다 먼저 — 아래 import들이 실행되기 전에 채워져야 한다
import './lib/polyfills';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ApiError, setUnauthorizedHandler } from './lib/api';
import './index.css';

// Sentry (P4, §12) — DSN이 빌드에 들어 있을 때만 켠다.
if (import.meta.env.VITE_SENTRY_DSN) {
  void import('@sentry/react').then((Sentry) =>
    Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN as string, tracesSampleRate: 0 }),
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // 화면 재진입 시 캐시를 먼저 그리고 뒤에서 갱신한다(스피너 재등장 방지).
      // 기본 5분이면 메뉴 몇 번 오가는 사이 캐시가 통째로 사라진다.
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 권한·검증 오류는 다시 시도해도 결과가 같다.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

// 리프레시까지 실패하면 로그인 화면으로 되돌린다.
setUnauthorizedHandler(() => {
  queryClient.clear();
  if (!window.location.pathname.startsWith('/login')) {
    window.location.assign('/login');
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
